import { RoleFormType } from 'components/roles/RoleForm';

export const createRoleInitialValues: Partial<RoleFormType> = {};
